<template>
	<div>
		<el-drawer title="添加员工" :wrapperClosable="false" :visible.sync="drawer" :direction="direction" :before-close="handleClose" size="600px">
			<div class="ml-24 mr-24" style="margin-bottom: 88px">
				<div class="flex-center flex-just-between mt-24">
					<div style="width: 164px" class="flex-center flex-just-between">
						<div class="font-h6-regular" style="width: 24px; height: 18px; flex-shrink: 0">部门</div>
						<div class="select">
							<!-- <dept-tree-select :collapseTags="true" :value="deptIdArr" class="ml-8" /> -->
							<dept-tree-select v-model="formData['deptIds']" :collapseTags="true" @input="deptTreeSelectFun" ref="deptTreeSelect" class="ml-12" />
						</div>
					</div>
					<div class="flex-center flex-just-start font-h5-regular input ml-16">
						<el-input placeholder="请输入员工名称" v-model="formData['userName']" clearable>
							<el-button slot="append" class="fz-13" @click="addEmployee">搜索</el-button>
						</el-input>
					</div>
				</div>
				<el-table
					class="mt-16"
					ref="multipleTable"
					:data="tableData"
					tooltip-effect="dark"
					style="width: 100%"
					@selection-change="handleSelectionChange"
					:loading="loading"
				>
					<el-table-column type="selection" :selectable="hasSelectFun"></el-table-column>
					<el-table-column label="员工名称" prop="nickname">
						<template #default="scope">
							<div style="display: flex">
								<span>{{ scope.row.name }}</span>
								<span
									class="font-h6-regular ml-4 flex-center pl-4 pr-4"
									:class="{ disableClass: scope.row.use_status === 1, deletedClass: scope.row.deleted }"
								>
									{{ scope.row.use_status === '2' ? '已停用' : scope.row.deleted ? '已删除' : '' }}
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="dept_name" label="部门"></el-table-column>
				</el-table>
			</div>
			<div class="flex-just-end flex-row flex-align-center yx-background-white footer">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" class="mr-16" @click="addUser">确认添加</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
import { getUsersListApi } from '@/api/performanceObjectives';
import { drRoleType } from '@/utils/dataMap';
export default {
	components: {
		deptTreeSelect,
	},
	props: {
		selectable: {
			type: Function,
			default: () => true,
		},
		filterFn: {
			type: Function,
			default: () => true,
		},
	},
	data() {
		return {
			drawer: false,
			direction: 'rtl',
			input: '',
			tableData: [],
			multipleSelection: [],
			formData: {
				deptIds: [],
				userName: '',
				userType: drRoleType.id,
			},
			loading: false,
			employList: [],
		};
	},
	// created() {
	//     this.addEmployee()
	// },
	watch: {
		formData: {
			handler: function () {
				this.addEmployee();
			},
			deep: true,
		},
	},
	methods: {
		hasSelectFun(row, index) {
			return this.selectable(row, index);
		},
		async show(list) {
			this.drawer = true;
			await this.addEmployee();
			if (list) {
				const selectList = list.map(select => this.tableData.find(row => row.id == select.userId)).filter(Boolean);
				this.toggleSelection(selectList);
			}
		},
		handleClose() {
			this.drawer = false;
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		async addEmployee() {
			try {
				this.loading = false;
				const { code, data } = await getUsersListApi({
					dataView: '1',
					all_status: '1',
					role_id: this.formData.userType,
					dept_id: this.formData.deptIds,
					user_name: this.formData.userName,
				});
				if (code !== 0) return;
				this.tableData = data.filter(item => this.filterFn(item));
			} finally {
				this.loading = true;
			}
		},
		deptTreeSelectFun(value) {
			this.formData.deptIds = value?.length ? value.split(',') : [];
		},
		addUser() {
			this.$emit('selectChange', this.multipleSelection);
			this.drawer = false;
		},
	},
};
</script>

<style lang="less" scoped>
.el-drawer {
	position: relative;

	.input {
		width: 372px;

		/deep/ .el-input--small .el-input__inner {
			font-size: 13px;
		}

		.el-button {
			background: #2475ff;
			border-radius: 0 4px 4px 0;
			color: #fff;
		}
	}

	.select {
		/deep/ .el-input__inner {
			width: 128px;
			height: 32px;
		}
	}

	.footer {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 64px;
		background-color: #fff;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.05);
		margin-right: 0;
		margin-left: 0;
		z-index: 1;
	}
	.deletedClass {
		color: #4e596a;
		background-color: #f7f8fa;
	}

	.disableClass {
		color: #fa2714;
		background-color: #fff3f2;
	}
}
</style>
